import { IconButton, InputBase, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles"
import { useColors } from "../../../../Context/ColorsContext";
import { MediaQuerys } from "../../../../styles/GlobalStyle";

const { tablet } = MediaQuerys;

export const CustomIconButton = styled(IconButton)(() => {
  const { colors } = useColors();
  return {
    borderRadius: 0,
    height: '100%',
    padding: '0 6px',
    margin: 0,
    pointerEvents: 'pointer',
    background: colors.buttonActionColor,
    color: colors.white,
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      opacity: 0.9,
      color: colors.white,
    }
  }
})

export const ButtonText = styled(Typography)(() => {
  return {
    textTransform: "capitalize",
    fontSize: '14px',
    [tablet]: {
      fontSize: "12px",
    },
  }
})

export const InputContainer = styled(Paper)(() => ({
  padding: '0px 0px 0px 10px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '32px',
  borderRadius: '8px',
  border: '1px solid #e0e0e0',
  overflow: 'hidden',
}));

export const InputText = styled(InputBase)(() => ({
  width: "100%",
  "& .MuiInputBase-input": {
    fontSize: "14px !important",
    [tablet]: {
      fontSize: "12px !important",
    }
  }
}));